// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "jquery/dist/jquery.min";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入模块后自动生效
import '@vant/touch-emulator';
Vue.use(ElementUI);
Vue.config.productionTip = false;
//高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  key: '3ff1107f83258c27f96c18417cca603c',
  // 插件集合 （插件按需引入）
  plugin: []
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// 适配
// 1rem = 16px
// iphone6  width = 375      16
//          height = 667  

// 字体大小 = 667 / 375 * 16
function calcSize() {
  var width = document.documentElement.clientWidth;
  var html = document.querySelector("html");
  if (width <= 1024) {
    // 设置html根标签的fontSize属性
    html.style.fontSize = 14 + "px";
  } else if (width > 1024) {
    // 设置html根标签的fontSize属性
    html.style.fontSize = 16 + "px";
  }
}
calcSize();
// 窗口重置大小时，调用函数修改根标签大小
window.onresize = function () {
  calcSize();
}


// WEBPACK FOOTER //
// ./src/main.js